const LanguagesDataList = [
  { id: 1, text: "En" },
  { id: 2, text: "Es" },
  { id: 3, text: "Fr" },
  { id: 4, text: "De" },
  { id: 5, text: "Ru" },
];

export default LanguagesDataList;